interface ProgressItem {
    label: string;
    value: number;
}

interface ProgressListCardProps {
    title: string;
    accent: string;
    items: ProgressItem[];
}

export function ProgressListCard({
    title,
    accent,
    items,
}: ProgressListCardProps) {
    return (
        <div className="rounded-2xl border border-border bg-card p-5">

            <h3 className="text-sm font-semibold">
                {title}
            </h3>

            <div className="mt-5 space-y-5">

                {items.map((item) => (

                    <div key={item.label}>

                        <div className="flex justify-between text-sm">

                            <span>
                                {item.label}
                            </span>

                            <span>
                                {item.value}%
                            </span>

                        </div>

                        <div className="mt-2 h-2 rounded-full bg-muted">

                            <div
                                className="h-full rounded-full transition-all duration-700"
                                style={{
                                    width: `${item.value}%`,
                                    background: accent,
                                }}
                            />

                        </div>

                    </div>

                ))}

            </div>

        </div>
    );
}